export const roleNames = {
  vendor: 'VENDOR',
  admin: 'ADMIN',
  subscriber: 'SUBSCRIBER',
  team_member: 'TEAMMEMBER',
  team_manager: 'TEAMMANAGER',
};
